'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});


var defaultShouldError = function defaultShouldError(_ref) {
  var values = _ref.values,
      nextProps = _ref.nextProps,
      initialRender = _ref.initialRender,
      lastFieldValidatorKeys = _ref.lastFieldValidatorKeys,
      fieldValidatorKeys = _ref.fieldValidatorKeys,
      structure = _ref.structure;

  if (initialRender) {
    return true;
  }
  return !structure.deepEqual(values, nextProps && nextProps.values) || !structure.deepEqual(lastFieldValidatorKeys, fieldValidatorKeys);
};
exports.default = defaultShouldError;


/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-form/lib/defaultShouldError.js
 ** module id = 740
 ** module chunks = 0
 **/